import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_2 = { class: "lots-table" }
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["onUpdate:modelValue", "onChange"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

import { ref, onMounted, reactive } from 'vue'
import AddLotForm from '@/components/AddLotForm.vue'
import Toast from 'primevue/toast'
import axios from 'axios'
import { api } from '@/api/http'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminPage',
  setup(__props) {

const toast = ref()

const lots = ref<any[]>([])
const editableLots = reactive<Record<string, any>>({})
const sizeInputs = reactive<Record<string, string>>({})

/**
 * LOAD LOTS
 */
const loadLots = async () => {
  try {
    const { data } = await api.get('/lots')

    lots.value = data

    data.forEach((lot: any) => {
      editableLots[lot.id] = {
        name: lot.name,
        maximum: lot.maximum,
        size: [...lot.size],
        fetch: lot.fetch,
        active: lot.active
      }

      sizeInputs[lot.id] = lot.size.join(', ')
    })
  } catch (err) {
    console.error('Ошибка загрузки лотов:', err)

    toast.value?.add({
      severity: 'error',
      summary: 'Ошибка загрузки лотов',
      life: 3000
    })
  }
}

/**
 * UPDATE SIZE INPUT
 */
const updateSizes = (id: string) => {
  const sizes = sizeInputs[id].split(',').map(item => parseFloat(item.trim()))

  editableLots[id].size = sizes.filter(item => !isNaN(item))
}

/**
 * SAVE LOT
 */
const saveLot = async (id: string) => {
  try {
    const dataToUpdate = { ...editableLots[id] }

    await api.put(`/lots/${id}`, dataToUpdate)

    const index = lots.value.findIndex(lot => lot.id === id)
    if (index !== -1) {
      lots.value[index] = {
        ...lots.value[index],
        ...dataToUpdate
      }
    }

    toast.value?.add({
      severity: 'success',
      summary: 'Изменения сохранены',
      life: 3000
    })
  } catch (err: unknown) {
    const message = axios.isAxiosError(err)
      ? err.response?.data?.message || 'Ошибка обновления лота'
      : 'Ошибка обновления лота'

    toast.value?.add({
      severity: 'error',
      summary: message,
      life: 3000
    })
  }
}

/**
 * DELETE LOT
 */
const deleteLot = async (id: string) => {
  try {
    await api.delete(`/lots/${id}`)

    lots.value = lots.value.filter(lot => lot.id !== id)

    delete editableLots[id]
    delete sizeInputs[id]

    toast.value?.add({
      severity: 'success',
      summary: 'Лот удалён',
      life: 3000
    })
  } catch (err: unknown) {
    const message = axios.isAxiosError(err)
      ? err.response?.data?.message || 'Ошибка при удалении лота'
      : 'Ошибка при удалении лота'

    toast.value?.add({
      severity: 'error',
      summary: message,
      life: 3000
    })
  }
}

/**
 * CONFIRM DELETE
 */
const confirmDelete = (id: string) => {
  if (confirm('Вы уверены, что хотите удалить этот лот?')) {
    deleteLot(id)
  }
}

onMounted(loadLots)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Toast), {
      ref_key: "toast",
      ref: toast
    }, null, 512),
    _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"text-align":"center"} }, "Админ-панель", -1)),
    _createElementVNode("table", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "ID"),
          _createElementVNode("th", null, "Название"),
          _createElementVNode("th", null, "Размеры"),
          _createElementVNode("th", null, "Запрос истории"),
          _createElementVNode("th", null, "Отображение лота"),
          _createElementVNode("th", null, "Действия")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lots.value, (lot) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: lot.id
          }, [
            _createElementVNode("td", null, _toDisplayString(lot.id), 1),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((editableLots[lot.id].name) = $event)
              }, null, 8, _hoisted_3), [
                [_vModelText, editableLots[lot.id].name]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((sizeInputs[lot.id]) = $event),
                onChange: ($event: any) => (updateSizes(lot.id))
              }, null, 40, _hoisted_4), [
                [_vModelText, sizeInputs[lot.id]]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((editableLots[lot.id].fetch) = $event)
              }, null, 8, _hoisted_5), [
                [_vModelCheckbox, editableLots[lot.id].fetch]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((editableLots[lot.id].active) = $event)
              }, null, 8, _hoisted_6), [
                [_vModelCheckbox, editableLots[lot.id].active]
              ])
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("button", {
                onClick: ($event: any) => (saveLot(lot.id)),
                class: "save-btn"
              }, "Сохранить", 8, _hoisted_8),
              _createElementVNode("button", {
                onClick: ($event: any) => (confirmDelete(lot.id)),
                class: "delete-btn"
              }, "Удалить", 8, _hoisted_9)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(AddLotForm)
    ])
  ]))
}
}

})